module.exports = __webpack_public_path__ + "65bc0bf360cfa4a13f1baf17b5ff5713.svg";